/**
 * Created by PuTi(编程即菩提) 7/7/17.
 */
var nb = require('../../core/js/nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        initData:function(){

        },
        setAppData:function(inData){
            this.setOpts(inData);
            this.set(nb.opts.appInitData,inData);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/nb/app/js/Model.js
// module id = 217
// module chunks = 35